import { Box } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import ContentWrap from "../../../DocLayout/Content/Index";
import CodeSnippet from "../../../components/CodeSnippet";
import { codeMap } from "@/PageCodeComponents/MerchantUserWalletModeAPI";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import {
  USER_TRANSFER,
  USER_TRANSFER_RECORD,
  USER_TRANSFER_RECORD_LIST,
} from "@/config";
import PostRequest from "@/components/PostRequest";
export default function Index() {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  return (
    <div>
      {/* 发起用户转账 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="apis-related-to-user-transfers" className="title">
              {translate("merchant_user_wallet_mode_API.text_77")}
            </Box>
            <Box id="initiate-user-transfers" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_78")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_79")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_TRANSFER} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "fromUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_80")}`,
                },
                {
                  name: "toUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "amount",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_55")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
                {
                  name: "remark",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_82")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_transfer"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 发起用户转账 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_44_"
                  )}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              {translate("merchant_user_wallet_mode_API.text_83")}
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_transfer"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户转账记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-transfer-records" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_84")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_85")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_TRANSFER_RECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_44")}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_59_"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_transfer_record"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户转账记录 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },

                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_46")}`,
                },
                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_86")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_87")}`,
                },

                {
                  name: "data.record.orderId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_88")}`,
                },
                {
                  name: "data.record.fromUserId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_89")}`,
                },
                {
                  name: "data.record.toUserId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_90")}`,
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_91")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.remark",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_92")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_transfer_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户转账历史记录 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="get-user-transfer-history" className="title_0">
              {translate("merchant_user_wallet_mode_API.text_93")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.text_94")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_TRANSFER_RECORD_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "fromUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_80")}`,
                },
                {
                  name: "toUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_81")}`,
                },

                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_31"
                  ) as any,
                }}
              />
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_32"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_transfer_record_list"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户转账历史记录 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "data.records[index].fromUserId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_89")}`,
                },
                {
                  name: "data.records[index].toUserId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_81")}`,
                },
                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_46")}`,
                },
                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_86")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_87")}`,
                },

                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_88")}`,
                },

                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_91")}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_23_1"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            "merchant_user_wallet_mode_API.text_30"
                          )},${translate(
                            "merchant_user_wallet_mode_API.text_32"
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_transfer_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
